import { createRoute, Outlet, redirect } from '@tanstack/react-router';
import { canUseFavorites } from '@/constants/role-policy';
import { buildLoginRedirectHref } from '@/lib/auth-redirect';
import { getAppRelativePath } from '@/lib/site-paths';
import { useAuthStore } from '@/stores/auth-store';
import { rootRoute } from '../__root';

export const myPageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'my-page',
  beforeLoad: ({ location }) => {
    const { user } = useAuthStore.getState();
    const relativePath = getAppRelativePath(location.pathname);

    if (!canUseFavorites(user?.roles)) {
      throw redirect({ href: buildLoginRedirectHref(location.href) });
    }

    if (relativePath === '/my-page') {
      throw redirect({ to: '/my-page/favorites' });
    }
  },
  component: MyPageLayout,
});

function MyPageLayout() {
  return (
    <div className="space-y-6" data-ai-id="my-page-route">
      <Outlet />
    </div>
  );
}
